import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  footer: {
    padding: theme.spacing(1.75, 3),
    borderTop: `1px solid ${theme.palette.grey[500_24]}`,
    backgroundColor: "#FAFBFC",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.75),
  },
  footerDivider: { width: 1, height: 16, backgroundColor: theme.palette.grey[500_32] },
  footerLink: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.grey[600],
    letterSpacing: 0.3,
    textDecoration: "none",
  },
}));
